import { getTrimmedString } from './getTrimmedString';
import { toSnakeCase } from './toSnakeCase';

export const getSnakeCaseItems = <T>(data: any[]): T[] => {
  const snakeCaseItems = data.map((item: any) => {
    const snakeCaseItem = Object.entries(item).reduce((acc, pair) => {
      const [key, value] = pair as [string, string | undefined];
      return {
        ...acc,
        [toSnakeCase(key)]: getTrimmedString(value),
      };
    }, {} as T);
    return snakeCaseItem;
  });
  return snakeCaseItems;
};
